module.exports = __webpack_public_path__ + "img/1 (79).5c45bafc.png";